export default __webpack_public_path__ + "static/media/rares-tarabega.c5f9fd88.png";